module.exports = __webpack_public_path__ + "img/Capa Operação Med 2.c3f449b6.png";